import React from "react";
type ReadingCardInfoProps = {
  label: string;
  text: string;
};
export default function ReadingCardInfo(props: ReadingCardInfoProps) {
  const { label, text } = props;

  return (
    <div className="w-full min-h-[73px]  h-full shadow-sm px-6 py-4 rounded-lg bg-white flex gap-8 flex-col">
      <div className="w-full flex flex-col  justify-center gap-[2px]">
        <h4 className="text-sm text-gray-400"> {label}</h4>
        <p className="text-sm text-gray-600"> {text}</p>
      </div>
    </div>
  );
}
